import { BREAKPOINTS } from "@/consts";
import type { IFileState, IPixabayImage } from "@/interfaces";

const getRequiredImageWidth = (): number => {
  const imageSize = BREAKPOINTS.desktop <= window.innerWidth ? 228 : 338;
  return imageSize * (window.devicePixelRatio || 1);
};

const toFileState = (images: IPixabayImage[]): IFileState[] => {
  const requiredImageWidth = getRequiredImageWidth();

  return images.map((image) => {
    // Pixabay use width or height.
    const desiredSize = Math.max(image.webformatWidth, image.webformatHeight);

    // Use the smaller image if it's ok for the requiredImageWidth
    const url =
      requiredImageWidth > desiredSize
        ? image.largeImageURL
        : image.webformatURL.replace("_640", `_${desiredSize}`);

    return {
      id: image.id.toString(),
      name: image.id?.toString(),
      url,
      largeURL: image.largeImageURL,
      size: image.imageSize,
      source: "pixabay",
      type: "image",
    };
  });
};

export default {
  toFileState,
};
